import { render, staticRenderFns } from "./modal_anamnese_detail.vue?vue&type=template&id=0540665e&scoped=true&"
import script from "./modal_anamnese_detail.vue?vue&type=script&lang=js&"
export * from "./modal_anamnese_detail.vue?vue&type=script&lang=js&"
import style0 from "./modal_anamnese_detail.vue?vue&type=style&index=0&id=0540665e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540665e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
